import gsap from 'gsap';
import $ from '../core/Dom';
import Viewport from '../core/Viewport';

export default el => {
    const shader = $(el).find('[data-menu-shader]');
    const wrapper = $(el).find('[data-menu-wrapper]');
    const menu = $(el).find('[data-menu]');
    const searchField = wrapper.find('[data-menu-field]');
    const btnOpen = $(el).find('[data-menu-open]');
    const hamburgerTop = btnOpen.find('i:nth-of-type(1)');
    const hamburgerMiddle = btnOpen.find('i:nth-of-type(2)');
    const hamburgerBottom = btnOpen.find('i:nth-of-type(3)');
    // const btnClose = $(el).find('[data-menu-close]');
    const backgrounds = $(el).find('[data-menu-background], [data-menu-bar]');

    let isOpen = false;

    const keyUpHandler = e => {
        const key = e.keyCode || e.which;
        if (isOpen && key === 27) {
            close();
        }
    };

    const xToHamburger = () => {
        btnOpen.attr('aria-label', 'Vis meny');
        gsap.to(hamburgerTop.nodes, { duration: 0.1, rotation: 0, ease: 'sine.in' });
        gsap.to(hamburgerBottom.nodes, {
            duration: 0.1,
            rotation: 0,
            ease: 'sine.in',
            onComplete: () => {
                hamburgerMiddle.css('opacity', 1);
                gsap.to(hamburgerTop.nodes, { duration: 0.2, y: 0, ease: 'quart.out', clearProps: 'all' });
                gsap.to(hamburgerBottom.nodes, { duration: 0.2, y: 0, ease: 'quart.out', clearProps: 'all' });
            }
        });
    };

    const hamburgerToX = () => {
        btnOpen.attr('aria-label', 'Skjul meny');
        const offset = parseInt(hamburgerTop.css('margin-bottom'), 10) + parseInt(hamburgerTop.css('height'), 10);
        gsap.to(hamburgerTop.nodes, { duration: 0.2, y: offset, ease: 'sine.in' });
        gsap.to(hamburgerBottom.nodes, {
            duration: 0.2,
            y: offset * -1,
            ease: 'sine.in',
            onComplete: () => {
                hamburgerMiddle.css('opacity', 0);
                gsap.to(hamburgerTop.nodes, { duration: 0.3, rotation: 45, ease: 'quart.out' });
                gsap.to(hamburgerBottom.nodes, { duration: 0.3, rotation: -45, ease: 'quart.out' });
            }
        });
    };

    const open = () => {
        console.log('open');
        isOpen = true;

        hamburgerToX();

        gsap.set(backgrounds.nodes, { x: '-100%' });
        gsap.set(shader.get(0), { opacity: 0 });
        gsap.set(wrapper.get(0), { opacity: 0, x: -30 });
        gsap.set(menu.get(0), { display: 'block' });

        gsap.to(shader.get(0), { duration: 0.3, opacity: 0.5, ease: 'circ.out' });
        gsap.to(backgrounds.nodes, { duration: 0.3, x: '0%', ease: 'circ.out' });
        gsap.to(wrapper.nodes, { duration: 1.5, delay: 0.15, x: 0, ease: 'expo.out' });
        gsap.to(wrapper.nodes, { duration: 0.5, delay: 0.15, opacity: 1, ease: 'sine.inOut' });

        Viewport.lockTabbing(el, searchField);
        document.addEventListener('keyup', keyUpHandler);
    };

    const close = () => {
        isOpen = false;

        xToHamburger();

        gsap.to(wrapper.nodes, { duration: 0.1, opacity: 0, ease: 'circ.out' });
        gsap.to(shader.get(0), { duration: 0.25, opacity: 0, ease: 'circ.out' });
        gsap.to(backgrounds.nodes, {
            duration: 0.25,
            x: '-100%',
            ease: 'circ.out',
            onComplete: () => {
                menu.attr('style', null);
            }
        });

        Viewport.releaseTabbing(btnOpen);
        document.removeEventListener('keyup', keyUpHandler);
    };

    const toggle = e => {
        e.preventDefault();
        if (isOpen) {
            close();
        } else {
            open();
        }
    };

    const init = () => {
        btnOpen.on('click', toggle);
        shader.on('click', close);
    };

    const destroy = () => {
        btnOpen.off('click');
        shader.off('click');
        Viewport.releaseTabbing();
        document.removeEventListener('keyup', keyUpHandler);
    };

    return {
        init,
        destroy
    };
};
